import { render, staticRenderFns } from "./orderChecklistItemList.vue?vue&type=template&id=673fc474&"
import script from "./orderChecklistItemList.vue?vue&type=script&lang=js&"
export * from "./orderChecklistItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports